import React, { Component } from 'react'


class PublicKey extends Component {
  constructor (props) {
    super(props)
    this.state = {
      value: props.value,
      is_open: props.is_open ? true : false
    }
  }

  render () {
    const { value, is_open } = this.state
    return (
      <div className='publickey-field'>
        <details open={is_open}>
          <summary>
            {value.slice(0,12)} 
            ... 
            {value.split(" ").slice(-1)}
          </summary>
          <code>{value}</code>
        </details>
      </div>
    )
  }
}

export { PublicKey }



// WEBPACK FOOTER //
// ./src/components/push_apis/PublicKey.js